import { ActivatedRoute } from '@angular/router';
import { OnInit } from '@angular/core';
import { ISession } from '../../models/session';
import { first, map, tap } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
export class SessionBase {
  public session: ISession;
  constructor() {}
  getSession(route$: Observable<{ [name: string]: any }>) {
    return this.getSession$(route$).subscribe();
  }
  getSession$(route$: Observable<{ [name: string]: any }>) {
    return route$.pipe(first(), map(route => route.data), tap(session => (this.session = session)));
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/session-base.ts